import { render } from "./HeaderStepBlockDesktop.vue?vue&type=template&id=58e1c557"
import script from "./HeaderStepBlockDesktop.vue?vue&type=script&lang=js"
export * from "./HeaderStepBlockDesktop.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__